// Global navigation labels + unsaved-changes guard (navigation adjustment).
export const extra9 = {
  pt: { "nav.back_home": "Voltar ao início", "nav.my_christmas": "Meu Natal",
    "unsaved.title": "Você possui alterações que ainda não foram salvas.",
    "unsaved.continue": "Continuar editando", "unsaved.leave": "Sair sem salvar" },
  en: { "nav.back_home": "Back to home", "nav.my_christmas": "My Christmas",
    "unsaved.title": "You have changes that haven't been saved yet.",
    "unsaved.continue": "Keep editing", "unsaved.leave": "Leave without saving" },
  es: { "nav.back_home": "Volver al inicio", "nav.my_christmas": "Mi Navidad",
    "unsaved.title": "Tienes cambios que aún no se han guardado.",
    "unsaved.continue": "Seguir editando", "unsaved.leave": "Salir sin guardar" },
  fr: { "nav.back_home": "Retour à l'accueil", "nav.my_christmas": "Mon Noël",
    "unsaved.title": "Vous avez des modifications non enregistrées.",
    "unsaved.continue": "Continuer l'édition", "unsaved.leave": "Quitter sans enregistrer" },
  it: { "nav.back_home": "Torna all'inizio", "nav.my_christmas": "Il mio Natale",
    "unsaved.title": "Hai modifiche non ancora salvate.",
    "unsaved.continue": "Continua a modificare", "unsaved.leave": "Esci senza salvare" },
};
